import { render, staticRenderFns } from "./SolarIndvPresentation.vue?vue&type=template&id=940081a2&scoped=true"
import script from "./SolarIndvPresentation.vue?vue&type=script&lang=js"
export * from "./SolarIndvPresentation.vue?vue&type=script&lang=js"
import style0 from "./SolarIndvPresentation.vue?vue&type=style&index=0&id=940081a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940081a2",
  null
  
)

export default component.exports